import { useContext } from '@/hooks'
import { watch } from '@vue/composition-api'

export function useWaterfall<TPrimaryValue = any>(
  name: string,
  options?: {
    reloadWatcher?: () => any
    reloadWatcherImmediate?: boolean
  },
) {
  const ctx = useContext()

  const reload = () =>
    // @ts-ignore
    ctx.$refs[name]?.reload()

  const record = (primaryValue: TPrimaryValue) =>
    // @ts-ignore
    ctx.$refs[name]?.record(primaryValue)

  const checkRecord = (primaryValue?: TPrimaryValue, delay?: number) =>
    // @ts-ignore
    ctx.$refs[name]?.checkRecord(primaryValue, delay)

  const getData = <T>(): T[] =>
    // @ts-ignore
    ctx.$refs[name]?.data || []

  if (options?.reloadWatcher) {
    watch(options.reloadWatcher, reload, {
      immediate: options.reloadWatcherImmediate,
    })
  }

  return {
    reload,
    record,
    checkRecord,
    getData,
  }
}
